const MurUsageBanner = () => {

    return(
        <>
            <section className="be-banner">
                <div className="">
                    <p className="be-banner-title">CHIFFRAGE : CHARPENTE TRADITIONNELLE</p>
                    <p className="be-centered-p">MUR ET USAGE</p>
                </div>
            </section>
        </>
    )

}

export default MurUsageBanner;